import React, { useEffect, useState, useRef, useImperativeHandle } from 'react';
import { isMobileFun, getPrefixField, createFilePath, convertStylesStringToObject, isVideo } from '../../utils/obj-utils';
import Detailss from '../../elements/InnerPageDetail';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import { Autoplay, Pagination, Navigation } from 'swiper';
import 'swiper/swiper.min.css';
import './style.scss';

export default function index(props) {
  const { fields } = props;
  const [tabsIndex, setTabsIndex] = useState(0);
  const [videoIndex, setVideoIndex] = useState(0);
  const [flag, setFlag] = useState(false);
  const [videoflag, setVideoflag] = useState(false);
  const [ismoreflag, setIsmoreflag] = useState(false);
  const swiperRef = useRef(null);
  const swiperconRef = useRef(null);
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);
  const isMobile = isMobileFun();
  const id = props?.params?.pagename;
  const [isclickNextPrev, setIsclickNextPrev] = useState(false);
  // sectionAction
  useImperativeHandle(props.eventRef, () => {
    if (props.eventRef) {
      return {
        sendEvent
      };
    }
  });
  const sendEvent = () => {
    window.Dmp.sectionAction(id);
    window.navigationIndex = props.fields.navigationIndex.value;
    window.navigationPagename = window.navigationPagenameb = id !== undefined ? id : '';
  };
  const windowhidden = () => {
    document.documentElement.style.overflow = 'hidden';
  };
  const closewindowhidden = () => {
    document.documentElement.style.overflow = 'auto';
    document.documentElement.style.overflowX = 'hidden';
  };

  return (
    <>
      <div className="price_exterior_v6" id={id}>
        <div className="hash"></div>
        <div className="con">
          {fields[`${getPrefixField('bghtml', isMobile)}`]?.value && (
            <div
              className="bg"
              style={convertStylesStringToObject(fields[`${getPrefixField('bgstyle', isMobile)}`]?.value)}
              dangerouslySetInnerHTML={{
                __html: fields[`${getPrefixField('bghtml', isMobile)}`]?.value?.replaceHtml()
              }}
            ></div>
          )}
          {fields?.lists.length > 0 && (
            <div className="control">
              {fields?.lists.map((item, index) => {
                return (
                  <div
                    className={`dot dot${index + 1}`}
                    key={index}
                    style={convertStylesStringToObject(item?.fields[`${getPrefixField('dotstyle', isMobile)}`]?.value)}
                    onClick={() => {
                      setFlag(true);
                      windowhidden();
                      setTabsIndex(index);
                      setVideoIndex(0);
                      window.Dmp.clickAction(item?.fields?.dotdmp?.value);
                    }}
                  ></div>
                );
              })}
            </div>
          )}
        </div>
        {flag && (
          <div className="prop_detail">
            <div
              className="close"
              style={convertStylesStringToObject(fields[`${getPrefixField('closeiconstyle', isMobile)}`]?.value)}
              onClick={() => {
                setFlag(false);
                closewindowhidden();
                window.Dmp.clickAction(fields?.closedmp?.value);
              }}
            >
              <img className="icon" src={createFilePath(fields[`${getPrefixField('closeicon', isMobile)}`]?.value)} alt="广汽本田" />
            </div>
            {!isMobile ? (
              <>
                <div className="top">
                  {fields?.lists.length > 0 && (
                    <div className="tabs">
                      {fields?.lists.map((item, index) => {
                        return (
                          <div
                            className={`item ${index === tabsIndex ? 'on' : ''}`}
                            key={index}
                            onClick={() => {
                              setTabsIndex(index);
                              setVideoIndex(0);
                              window.Dmp.clickAction(item?.fields?.tabsdmp?.value);
                            }}
                          >
                            <div
                              dangerouslySetInnerHTML={{ __html: item?.fields[`${getPrefixField('name', isMobile)}`]?.value?.replaceHtml() }}
                            ></div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
                <div className="video">
                  {fields?.lists[tabsIndex].fields?.videolist[videoIndex].fields[`${getPrefixField('img', isMobile)}`]?.value && (
                    <>
                      <img
                        className="img"
                        style={convertStylesStringToObject(
                          fields?.lists[tabsIndex].fields?.videolist[videoIndex].fields[`${getPrefixField('imgstyle', isMobile)}`]?.value
                        )}
                        src={createFilePath(
                          fields?.lists[tabsIndex].fields?.videolist[videoIndex].fields[`${getPrefixField('img', isMobile)}`]?.value
                        )}
                        alt="广汽本田"
                      />
                      {fields?.lists[tabsIndex].fields?.videolist[videoIndex].fields[`${getPrefixField('lo', isMobile)}`]?.value &&
                        fields?.lists[tabsIndex].fields?.videolist[videoIndex].fields?.iscover?.value && (
                          <img
                            className="firstlo"
                            style={convertStylesStringToObject(
                              fields?.lists[tabsIndex].fields?.videolist[videoIndex].fields[`${getPrefixField('lostyle', isMobile)}`]?.value
                            )}
                            src={createFilePath(
                              fields?.lists[tabsIndex].fields?.videolist[videoIndex].fields[`${getPrefixField('lo', isMobile)}`]?.value
                            )}
                            alt="广汽本田"
                          />
                        )}
                      {fields?.lists[tabsIndex].fields?.videolist[videoIndex].fields?.video?.value && (
                        <div
                          className="play"
                          style={convertStylesStringToObject(fields[`${getPrefixField('playiconstyle', isMobile)}`]?.value)}
                          onClick={() => {
                            setVideoflag(true);
                            window.Dmp.clickAction(
                              fields?.lists[tabsIndex].fields?.videolist[videoIndex].fields?.playdmp?.value,
                              createFilePath(fields?.lists[tabsIndex].fields?.videolist[videoIndex].fields?.video?.value)
                            );
                          }}
                        >
                          <img className="icon" src={createFilePath(fields[`${getPrefixField('playicon', isMobile)}`]?.value)} alt="广汽本田" />
                        </div>
                      )}
                    </>
                  )}
                </div>
                <div className="bottom">
                  {fields?.lists[tabsIndex].fields?.videolist.length > 0 && (
                    <>
                      {fields?.lists[tabsIndex].fields?.videolist.length > 5 ? (
                        <div className="videolist">
                          <Swiper
                            ref={swiperRef}
                            slidesPerView={5}
                            className={`swiper ${fields?.lists[tabsIndex].fields?.videolist.length < 4 ? 'swiper-center' : ''}`}
                            spaceBetween={10}
                            initialSlide={0}
                            observer={true}
                            resizeObserver={true}
                            updateOnWindowResize={true}
                            modules={[Pagination, Navigation]}
                            navigation={{
                              prevEl: navigationPrevRef.current,
                              nextEl: navigationNextRef.current,
                              disabledClass: 'disabled'
                            }}
                            onSwiper={(swiper) => {
                              setTimeout(() => {
                                swiper.params.navigation.prevEl = navigationPrevRef.current;
                                swiper.params.navigation.nextEl = navigationNextRef.current;
                                swiper.navigation.destroy();
                                swiper.navigation.init();
                                swiper.navigation.update();
                              });
                            }}
                            onSlideChangeTransitionEnd={(e) => {}}
                          >
                            {fields?.lists[tabsIndex].fields?.videolist.map((item, index) => {
                              return (
                                <SwiperSlide
                                  className={`item ${index === videoIndex ? 'on' : ''}`}
                                  key={index}
                                  onClick={() => {
                                    setVideoIndex(index);
                                    window.Dmp.clickAction(item?.fields?.videodmp?.value);
                                  }}
                                >
                                  <div className="pic">
                                    {item?.fields[`${getPrefixField('smallimg', isMobile)}`]?.value && (
                                      <div className="img">
                                        <img
                                          style={convertStylesStringToObject(item?.fields[`${getPrefixField('smallimgstyle', isMobile)}`]?.value)}
                                          src={createFilePath(item?.fields[`${getPrefixField('smallimg', isMobile)}`]?.value)}
                                          alt="广汽本田"
                                        />
                                      </div>
                                    )}
                                    {item?.fields[`${getPrefixField('lo', isMobile)}`]?.value && item.fields?.video?.value && (
                                      <img
                                        className="lo"
                                        data={item.fields?.video?.value}
                                        style={convertStylesStringToObject(item?.fields[`${getPrefixField('lostyle', isMobile)}`]?.value)}
                                        src={createFilePath(item?.fields[`${getPrefixField('lo', isMobile)}`]?.value)}
                                        alt="广汽本田"
                                      />
                                    )}
                                    {item.fields?.video?.value && (
                                      <div
                                        className="play2"
                                        style={convertStylesStringToObject(fields[`${getPrefixField('playicon2style', isMobile)}`]?.value)}
                                      >
                                        <img
                                          className="icon"
                                          src={createFilePath(fields[`${getPrefixField('playicon2', isMobile)}`]?.value)}
                                          alt="广汽本田"
                                        />
                                      </div>
                                    )}
                                  </div>
                                  <div
                                    className="right"
                                    dangerouslySetInnerHTML={{ __html: item?.fields[`${getPrefixField('text', isMobile)}`]?.value?.replaceHtml() }}
                                  ></div>
                                </SwiperSlide>
                              );
                            })}
                          </Swiper>
                          <div
                            className="next"
                            ref={navigationNextRef}
                            data-html-item={fields?.nextdmp?.value}
                            style={convertStylesStringToObject(fields[`${getPrefixField('nexticonstyle', isMobile)}`]?.value)}
                          >
                            <img className="icon" src={createFilePath(fields[`${getPrefixField('nexticon', isMobile)}`]?.value)} alt="广汽本田" />
                          </div>
                          <div
                            className="prev"
                            ref={navigationPrevRef}
                            data-html-item={fields?.prevdmp?.value}
                            style={convertStylesStringToObject(fields[`${getPrefixField('previconstyle', isMobile)}`]?.value)}
                          >
                            <img className="icon" src={createFilePath(fields[`${getPrefixField('previcon', isMobile)}`]?.value)} alt="广汽本田" />
                          </div>
                        </div>
                      ) : (
                        <div className="videolist">
                          <div ref={swiperRef} className={'swiper swiper-center'}>
                            {fields?.lists[tabsIndex].fields?.videolist.map((item, index) => {
                              return (
                                <div
                                  className={`item ${index === videoIndex ? 'on' : ''}`}
                                  key={index}
                                  onClick={() => {
                                    setVideoIndex(index);
                                    window.Dmp.clickAction(item?.fields?.videodmp?.value);
                                  }}
                                >
                                  <div className="pic">
                                    {item?.fields[`${getPrefixField('smallimg', isMobile)}`]?.value && (
                                      <div className="img">
                                        <img
                                          style={convertStylesStringToObject(item?.fields[`${getPrefixField('smallimgstyle', isMobile)}`]?.value)}
                                          src={createFilePath(item?.fields[`${getPrefixField('smallimg', isMobile)}`]?.value)}
                                          alt="广汽本田"
                                        />
                                      </div>
                                    )}
                                    {item?.fields[`${getPrefixField('lo', isMobile)}`]?.value && item.fields?.video?.value && (
                                      <img
                                        className="lo"
                                        style={convertStylesStringToObject(item?.fields[`${getPrefixField('lostyle', isMobile)}`]?.value)}
                                        src={createFilePath(item?.fields[`${getPrefixField('lo', isMobile)}`]?.value)}
                                        alt="广汽本田"
                                      />
                                    )}
                                    {item.fields?.video?.value && (
                                      <div
                                        className="play2"
                                        style={convertStylesStringToObject(fields[`${getPrefixField('playicon2style', isMobile)}`]?.value)}
                                      >
                                        <img
                                          className="icon"
                                          src={createFilePath(fields[`${getPrefixField('playicon2', isMobile)}`]?.value)}
                                          alt="广汽本田"
                                        />
                                      </div>
                                    )}
                                  </div>
                                  <div
                                    className="right"
                                    dangerouslySetInnerHTML={{ __html: item?.fields[`${getPrefixField('text', isMobile)}`]?.value?.replaceHtml() }}
                                  ></div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </>
            ) : (
              <>
                <div className="top">
                  {fields?.lists.length > 0 && (
                    <>
                      <Swiper
                        ref={swiperRef}
                        slidesPerView={5}
                        className={'tabs'}
                        spaceBetween={0}
                        initialSlide={0}
                        observer={true}
                        resizeObserver={true}
                        updateOnWindowResize={true}
                        modules={[Pagination, Navigation]}
                        navigation={{
                          prevEl: navigationPrevRef.current,
                          nextEl: navigationNextRef.current,
                          disabledClass: 'disabled'
                        }}
                        onSwiper={(swiper) => {
                          setTimeout(() => {
                            swiper.params.navigation.prevEl = navigationPrevRef.current;
                            swiper.params.navigation.nextEl = navigationNextRef.current;
                            swiper.navigation.destroy();
                            swiper.navigation.init();
                            swiper.navigation.update();
                          });
                        }}
                        onSlideChangeTransitionEnd={(e) => {}}
                      >
                        {fields?.lists.map((item, index) => {
                          return (
                            <SwiperSlide
                              className={`item ${index === tabsIndex ? 'on' : ''}`}
                              key={index}
                              onClick={() => {
                                setTabsIndex(index);
                                if (swiperconRef.current) {
                                  swiperconRef.current.swiper.slideTo(index);
                                }
                                setIsclickNextPrev(true);
                                window.Dmp.clickAction(item?.fields?.tabsdmp?.value);
                              }}
                            >
                              <div
                                dangerouslySetInnerHTML={{ __html: item?.fields[`${getPrefixField('name', isMobile)}`]?.value?.replaceHtml() }}
                              ></div>
                            </SwiperSlide>
                          );
                        })}
                      </Swiper>
                      <div
                        className="next"
                        ref={navigationNextRef}
                        data-html-item={fields?.nextdmp?.value}
                        style={convertStylesStringToObject(fields[`${getPrefixField('nexticonstyle', isMobile)}`]?.value)}
                      >
                        <img className="icon" src={createFilePath(fields[`${getPrefixField('nexticon', isMobile)}`]?.value)} alt="广汽本田" />
                      </div>
                      <div
                        className="prev"
                        ref={navigationPrevRef}
                        data-html-item={fields?.prevdmp?.value}
                        style={convertStylesStringToObject(fields[`${getPrefixField('previconstyle', isMobile)}`]?.value)}
                      >
                        <img className="icon" src={createFilePath(fields[`${getPrefixField('previcon', isMobile)}`]?.value)} alt="广汽本田" />
                      </div>
                    </>
                  )}
                </div>
                <Swiper
                  ref={swiperconRef}
                  slidesPerView={1}
                  className={'con'}
                  spaceBetween={0}
                  initialSlide={0}
                  observer={true}
                  resizeObserver={true}
                  updateOnWindowResize={true}
                  onSlideChangeTransitionEnd={(e) => {
                    setTabsIndex(e.activeIndex);
                    setVideoIndex(0);
                    if (swiperRef.current) {
                      swiperRef.current.swiper.slideTo(e.activeIndex);
                    }
                  }}
                  onSlidePrevTransitionEnd={(e) => {
                    if (fields?.swpprevdmp?.value && !isclickNextPrev) {
                      window.Dmp.clickAction(fields?.swpprevdmp?.value);
                    }
                    setIsclickNextPrev(false);
                  }}
                  onSlideNextTransitionEnd={(e) => {
                    if (fields?.swpnextdmp?.value && !isclickNextPrev) {
                      window.Dmp.clickAction(fields?.swpnextdmp?.value);
                    }
                    setIsclickNextPrev(false);
                  }}
                >
                  {fields?.lists.map((item, index) => {
                    return (
                      <SwiperSlide className={'item'} key={index}>
                        {item.fields?.videolist.length > 0 &&
                          item.fields?.videolist.map((item2, index) => {
                            return item2.fields?.iscover?.value ? (
                              <div className="video" key="index">
                                {item2.fields[`${getPrefixField('img', isMobile)}`]?.value && (
                                  <>
                                    <img
                                      className="img"
                                      style={convertStylesStringToObject(item2.fields[`${getPrefixField('imgstyle', isMobile)}`]?.value)}
                                      src={createFilePath(item2.fields[`${getPrefixField('img', isMobile)}`]?.value)}
                                      alt="广汽本田"
                                    />
                                  </>
                                )}
                                {item2.fields[`${getPrefixField('lo', isMobile)}`]?.value && (
                                  <img
                                    className="firstlo"
                                    style={convertStylesStringToObject(item2.fields[`${getPrefixField('lostyle', isMobile)}`]?.value)}
                                    src={createFilePath(item2.fields[`${getPrefixField('lo', isMobile)}`]?.value)}
                                    alt="广汽本田"
                                  />
                                )}
                              </div>
                            ) : (
                              ''
                            );
                          })}

                        {item.fields?.videolist.length > 1 && (
                          <div className="more">
                            {fields[`${getPrefixField('moreimg', isMobile)}`]?.value && (
                              <img
                                className="icon"
                                style={convertStylesStringToObject(fields[`${getPrefixField('moreimgstyle', isMobile)}`]?.value)}
                                src={createFilePath(fields[`${getPrefixField('moreimg', isMobile)}`]?.value)}
                                alt="广汽本田"
                              />
                            )}
                            {fields[`${getPrefixField('moretext', isMobile)}`]?.value && (
                              <div
                                dangerouslySetInnerHTML={{ __html: fields[`${getPrefixField('moretext', isMobile)}`]?.value?.replaceHtml() }}
                              ></div>
                            )}
                          </div>
                        )}
                        <div className="bottom">
                          {item.fields?.videolist.length > 0 && (
                            <>
                              <div className="videolist">
                                {item.fields?.videolist.map((item2, index) => {
                                  return (
                                    !item2.fields?.iscover?.value && (
                                      <div
                                        className={`item ${index === videoIndex ? 'on' : ''}`}
                                        key={index}
                                        onClick={() => {
                                          setVideoIndex(index);
                                          setVideoflag(true);
                                          window.Dmp.clickAction(item2.fields?.playdmp?.value, createFilePath(item2.fields?.video?.value));
                                        }}
                                      >
                                        <div className="pic">
                                          {item2?.fields[`${getPrefixField('smallimg', isMobile)}`]?.value && (
                                            <div className="img">
                                              <img
                                                style={convertStylesStringToObject(
                                                  item2?.fields[`${getPrefixField('smallimgstyle', isMobile)}`]?.value
                                                )}
                                                src={createFilePath(item2?.fields[`${getPrefixField('smallimg', isMobile)}`]?.value)}
                                                alt="广汽本田"
                                              />
                                            </div>
                                          )}
                                          {item2?.fields[`${getPrefixField('lo', isMobile)}`]?.value && (
                                            <img
                                              className="lo"
                                              style={convertStylesStringToObject(item2?.fields[`${getPrefixField('lostyle', isMobile)}`]?.value)}
                                              src={createFilePath(item2?.fields[`${getPrefixField('lo', isMobile)}`]?.value)}
                                              alt="广汽本田"
                                            />
                                          )}
                                          {item2.fields?.video?.value && (
                                            <div
                                              className="play2"
                                              style={convertStylesStringToObject(fields[`${getPrefixField('playicon2style', isMobile)}`]?.value)}
                                            >
                                              <img
                                                className="icon"
                                                src={createFilePath(fields[`${getPrefixField('playicon2', isMobile)}`]?.value)}
                                                alt="广汽本田"
                                              />
                                            </div>
                                          )}
                                        </div>
                                        <div
                                          className="right"
                                          dangerouslySetInnerHTML={{
                                            __html: item2?.fields[`${getPrefixField('text', isMobile)}`]?.value?.replaceHtml()
                                          }}
                                        ></div>
                                      </div>
                                    )
                                  );
                                })}
                              </div>
                            </>
                          )}
                        </div>
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
              </>
            )}
          </div>
        )}
        {videoflag && (
          <Detailss routePath={fields?.lists[tabsIndex].fields?.videolist[videoIndex].fields?.detailurl?.value} close={() => setVideoflag(false)} />
        )}
      </div>
    </>
  );
}
